
import common from './Common'
import api from './Api'
import Vue from 'vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(AlertPlugin)

let isDebug = location.host.indexOf('nongwanjia.net') != -1 ? false : true;

export default {


queryWechatConfigure(){

const opts = {
url: api.wxConfig,
data:{
url: encodeURIComponent(location.href.split("#")[0]),
},
type: 'get',
}

return new Promise( (resolve,reject)=>{
common.query(opts).then(res=>{
resolve(res.data);
},res=>{
Vue.$vux.alert.show('微信配置失败')
});
})
},


initWechat(wechat){
let _this = this;
return new Promise( (resolve,reject)=>{
const options = {
debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: wechat.appId, // 必填，公众号的唯一标识
timestamp: wechat.timestamp, // 必填，生成签名的时间戳
nonceStr: wechat.nonceStr, // 必填，生成签名的随机串
signature: wechat.signature,// 必填，签名，见附录1
jsApiList: [
"chooseImage",
"previewImage",
"uploadImage",
"downloadImage",
"getLocation",
"openLocation"


] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
}

wx.config(options);
wx.ready(function(res){

resolve(res);
});
wx.error(function(res){



reject(res);
})
});

},


getUserLocation(){

const _this = this;

return new Promise( (resolve,reject)=>{








wx.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
success: function (res) {
resolve(res);
},
cancel: function(res){
_this.getUserLocation();
},
fail:function(res){

}
});

})

}


}



// WEBPACK FOOTER //
// ./src/assets/js/weixin.js